<template>
  <div class="user-ip-info">
    <ConfigTable ref="ct" :defaultParams="defaultParams" :searchConfig="searchConfig" :tableColumns="tableColumns"
      :tableData="list" :total="total" @change="loadData" @output="output"></ConfigTable>
  </div>
</template>

<script>
import ConfigTable from '@/components/config-table';
import userApi from '../../../api/user';
import moment from 'moment';

const searchConfig = [
  { type: 'daterange', label: '日期：', startPlaceholder: '开始日期', endPlaceholder: '结束日期', clearable: false, key: 'startTime', keys: ['startTime', 'endTime'] },
  { type: 'number', label: '总条数：', placeholder: '获取多少行', min: 5, key: 'limit' },
  { type: 'number', label: '注册数量：', placeholder: '最少注册数限制', min: 5, key: 'minRegisterLimit' },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', hidden: true, icon: 'copy-document', placeholder: '复制', key: 'output' },
]
const tableColumns = [
  { name: '注册IP', key: 'ip', width: 220 },
  { name: '注册数量', width: 220, key: 'registerCount' }
];
const dateFormater = 'YYYY-MM-DD'
const startDate = moment().add(-7, 'days').format()
const endDate = moment().format()
export default {
  name: 'UserIpInfo',
  components: { ConfigTable },
  data() {
    return {
      tableColumns,
      total: 0,
      list: [],
      defaultParams: {
        minRegisterLimit: 5,
        limit: 10,
        startTime: [startDate, endDate],
      }
    };
  },
  computed: {
    searchConfig() {
      searchConfig[searchConfig.length - 1].hidden = !(this.list && this.list.length)
      return searchConfig
    }
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await userApi.getIpInfo(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
        if (r.code !== 200) {
          this.$message.error(r.data)
        }
      } catch (error) {
        console.error('搜索ip刷量失败：', error);
      }
    },
    async output() {
      if (!this.list || !this.list.length) {
        this.$message.error('数据为空！')
        return
      }
      try {
        const copyText = this.list.map(ir => `IP:${ir.ip}, 注册：${ir.registerCount}次`).join('\n')
        console.log(copyText);
        await this.copyToClipboard(copyText)
        this.$message.success('复制成功')
      } catch (error) {
        this.$message.success('复制失败：', + error)
      }
    },
    async copyToClipboard(text) {
      navigator.clipboard.writeText(text)
    }
  }
};
</script>

<style lang="scss" scoped>
.user-ip-info {
}
</style>